import { defineNuxtPlugin } from '#app/nuxt'
import { LazyIaAccordion, LazyIaAlert, LazyIaAlertCloseButton, LazyIaGlobalAlert, LazyIaAvailabilityStatusIndicator, LazyIaAvailabilityStatusIndicatorMark, LazyIaBadge, LazyIaButton, LazyIaCard, LazyIaCarouselControls, LazyIaCloseButton, LazyIaContainer, LazyIaCoupon, LazyIaCouponBlock, LazyIaCouponTag, LazyIaDiscountTag, LazyIaHeading, LazyIaIconShowcase, LazyIaImagePlaceholder, LazyIaLink, LazyIaLoadingSpinner, LazyIaNotification, LazyIaPagination, LazyIaParagraph, LazyIaPills, LazyIaPopover, LazyIaPopper, LazyIaPoweredByIa, LazyIaPlaceRating, LazyIaPlaceStar, LazyIaRating, LazyIaRatingBars, LazyIaRatingPercent, LazyIaReview, LazyIaStar, LazyIaSkeleton, LazyIaSliderControl, LazyIaSuccessCheckMark, LazyIaTabHead, LazyIaTabHeadVertical, LazyIaTabs, LazyIaTag, LazyIaThemeIcon, LazyIaCarousel, LazyIaCarouselDots, LazyIaCarouselFooter, LazyIaCarouselGrid, LazyIaCarouselGridSlide, LazyIaCarouselSlide, LazyIaCarouselTitle, LazyIaFilterAccordion, LazyIaFilterItem, LazyIaCheckbox, LazyIaDatePicker, LazyIaInput, LazyIaInputGroup, LazyIaInputMessage, LazyIaInputWrapper, LazyIaPasswordField, LazyIaRadio, LazyIaRadioGroup, LazyIaSelect, LazyIaSelectField, LazyIaSlider, LazyIaTextField, LazyIaTextarea, LazyIaToggleSwitch, LazyIaBackdrop, LazyIaBottomSheet, LazyIaModalBase, LazyIaModalConfirm, LazyIaModalInfo, LazyIaModalRating, LazyIaModalSimple, LazyIaBulletStep, LazyIaStepper } from '#components'
const lazyGlobalComponents = [
  ["IaAccordion", LazyIaAccordion],
["IaAlert", LazyIaAlert],
["IaAlertCloseButton", LazyIaAlertCloseButton],
["IaGlobalAlert", LazyIaGlobalAlert],
["IaAvailabilityStatusIndicator", LazyIaAvailabilityStatusIndicator],
["IaAvailabilityStatusIndicatorMark", LazyIaAvailabilityStatusIndicatorMark],
["IaBadge", LazyIaBadge],
["IaButton", LazyIaButton],
["IaCard", LazyIaCard],
["IaCarouselControls", LazyIaCarouselControls],
["IaCloseButton", LazyIaCloseButton],
["IaContainer", LazyIaContainer],
["IaCoupon", LazyIaCoupon],
["IaCouponBlock", LazyIaCouponBlock],
["IaCouponTag", LazyIaCouponTag],
["IaDiscountTag", LazyIaDiscountTag],
["IaHeading", LazyIaHeading],
["IaIconShowcase", LazyIaIconShowcase],
["IaImagePlaceholder", LazyIaImagePlaceholder],
["IaLink", LazyIaLink],
["IaLoadingSpinner", LazyIaLoadingSpinner],
["IaNotification", LazyIaNotification],
["IaPagination", LazyIaPagination],
["IaParagraph", LazyIaParagraph],
["IaPills", LazyIaPills],
["IaPopover", LazyIaPopover],
["IaPopper", LazyIaPopper],
["IaPoweredByIa", LazyIaPoweredByIa],
["IaPlaceRating", LazyIaPlaceRating],
["IaPlaceStar", LazyIaPlaceStar],
["IaRating", LazyIaRating],
["IaRatingBars", LazyIaRatingBars],
["IaRatingPercent", LazyIaRatingPercent],
["IaReview", LazyIaReview],
["IaStar", LazyIaStar],
["IaSkeleton", LazyIaSkeleton],
["IaSliderControl", LazyIaSliderControl],
["IaSuccessCheckMark", LazyIaSuccessCheckMark],
["IaTabHead", LazyIaTabHead],
["IaTabHeadVertical", LazyIaTabHeadVertical],
["IaTabs", LazyIaTabs],
["IaTag", LazyIaTag],
["IaThemeIcon", LazyIaThemeIcon],
["IaCarousel", LazyIaCarousel],
["IaCarouselDots", LazyIaCarouselDots],
["IaCarouselFooter", LazyIaCarouselFooter],
["IaCarouselGrid", LazyIaCarouselGrid],
["IaCarouselGridSlide", LazyIaCarouselGridSlide],
["IaCarouselSlide", LazyIaCarouselSlide],
["IaCarouselTitle", LazyIaCarouselTitle],
["IaFilterAccordion", LazyIaFilterAccordion],
["IaFilterItem", LazyIaFilterItem],
["IaCheckbox", LazyIaCheckbox],
["IaDatePicker", LazyIaDatePicker],
["IaInput", LazyIaInput],
["IaInputGroup", LazyIaInputGroup],
["IaInputMessage", LazyIaInputMessage],
["IaInputWrapper", LazyIaInputWrapper],
["IaPasswordField", LazyIaPasswordField],
["IaRadio", LazyIaRadio],
["IaRadioGroup", LazyIaRadioGroup],
["IaSelect", LazyIaSelect],
["IaSelectField", LazyIaSelectField],
["IaSlider", LazyIaSlider],
["IaTextField", LazyIaTextField],
["IaTextarea", LazyIaTextarea],
["IaToggleSwitch", LazyIaToggleSwitch],
["IaBackdrop", LazyIaBackdrop],
["IaBottomSheet", LazyIaBottomSheet],
["IaModalBase", LazyIaModalBase],
["IaModalConfirm", LazyIaModalConfirm],
["IaModalInfo", LazyIaModalInfo],
["IaModalRating", LazyIaModalRating],
["IaModalSimple", LazyIaModalSimple],
["IaBulletStep", LazyIaBulletStep],
["IaStepper", LazyIaStepper],
  
]

export default defineNuxtPlugin({
  name: 'nuxt:global-components',
  setup (nuxtApp) {
    for (const [name, component] of lazyGlobalComponents) {
      nuxtApp.vueApp.component(name, component)
      nuxtApp.vueApp.component('Lazy' + name, component)
    }
  }
})
